export default {
      id: "units__parking_bg-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#units__parking_bg",
      toString: function () {
        return this.url;
      }
    }